import React, {useRef, useState, useEffect, useCallback} from "react";
import { useSelector } from "react-redux";

import NumberStepper from "../../../ui/molecules/NumberStepper";

import SpaceSettingModel from "../../../../models/SpaceSetting";

export default function FreeTrial(props) {
  const timeoutRef = useRef(null);

  const [freeTrial, setFreeTrial] = useState(null);

  const space = useSelector((state) => state.space);

  const debouncedSetFreeTrial = useCallback((value) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setFreeTrial(value > 365 ? 365 : value < 0 ? 0 : value);
    }, props.inner ? 0 : 1000);
  }, []);

  useEffect(() => {
    if (freeTrial !== null) {
      if (props.inner) {
        props.onUpdate({ trial_period: freeTrial || 0 });
      } else {
        onUpdate({ pod_payment_settings_attributes: { trial_period: freeTrial || 0 } });
      }
    }
  }, [freeTrial]);

  const onUpdate = (params) => {
    if (Object.keys(params).length === 0){
      return
    }
    SpaceSettingModel.onUpdate(
      space.slug,
      params,
      (data) => {},
      (data) => {}
    );
  };

  return (
    <NumberStepper
      label="Add free trial days (optional)"
      value={freeTrial}
      onChange={debouncedSetFreeTrial}
      min={0}
      max={365}
      defaultValue={props.defaultTrialPeriod}
    />
  );
}
